'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function AmindRelation(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M851.648 355.264l45.92-94.176a32 32 0 0 1 57.536 28.064l-84.16 172.576a32 32 0 0 1-42.784 14.72l-172.576-84.16a32 32 0 1 1 28.064-57.536l110.208 53.76A288 288 0 0 0 224 448a32 32 0 0 1-64 0C160 253.6 317.6 96 512 96c162.304 0 298.944 109.856 339.648 259.264zM128 608h288a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32v-128a32 32 0 0 0-32-32H160z m448-64h288a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64h-288a64 64 0 0 1-64-64v-192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32v-128a32 32 0 0 0-32-32h-224z' })
  );
}
AmindRelation.displayName = 'AmindRelation';

module.exports = AmindRelation;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/amindRelation.js
// module id = 144
// module chunks = 0